import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@mui/material';

import { CloseOutlined } from '@mui/icons-material';

import MedicationsAdd from '../../../../../Common/components/Template/Rx/ApRx-Medications';
import MedicationsList from '../../../../../Common/components/Template/Rx/ApRx-MedicationList';

import CommonDialogActions from '../../../../../Common/components/CommonDialogActions';

import { dialogHeaderStyles } from '../../../../../Common/components/Styles/InputStyles';

import { rxDialogStyles } from '../../../../../Common/components/Template/Rx/RxDialogStyles';

const initialSelectedMedications = [
  {
    id: 1,
    name: 'Biotin Supplement',
    dosage: '10',
    directions: '1-0-0',
    quantity: 20,
    refill: 1
  },
  {
    id: 2,
    name: 'Telekast',
    dosage: '10',
    directions: '0-1-0',
    quantity: 20,
    refill: 1
  }
];

const availableMedications = [
  {
    id: 1,
    name: 'Biotin Supplement',
    dosage: '10',
    directions: '1-0-0',
    quantity: 20,
    refill: 1
  },
  {
    id: 2,
    name: 'Telekast',
    dosage: '10',
    directions: '0-1-0',
    quantity: 20,
    refill: 1
  },
  {
    id: 3,
    name: 'Lisinopril',
    dosage: '20',
    directions: '0-0-1',
    quantity: 30,
    refill: 1
  },
  {
    id: 4,
    name: 'Omeprazole',
    dosage: '20',
    directions: '0-0-1',
    quantity: 30,
    refill: 2
  },
  {
    id: 5,
    name: 'Atorvastatin',
    dosage: '40',
    directions: '1-0-0',
    quantity: 30,
    refill: 1
  }
];

const RxDialog = ({ open, onClose, onSignAndClose, onSignAndPrint }) => {
  const [selectedMedications, setSelectedMedications] = useState(
    initialSelectedMedications
  );

  const [comments, setComments] = useState('');

  const selectedMedicationIds = selectedMedications.map(
    medication => medication.id
  );

  const handleAddMedication = medication => {
    setSelectedMedications(previous => [...previous, medication]);
  };

  const handleSelectMedication = medication => {
    if (selectedMedicationIds.includes(medication.id)) return;

    setSelectedMedications(previous => [...previous, medication]);
  };

  const handleDeleteMedication = medicationId => {
    setSelectedMedications(previous =>
      previous.filter(medication => medication.id !== medicationId)
    );
  };

  const handleEditMedication = medication => {
    // Open an edit state or populate the input row here.
    console.log('Edit medication:', medication);
  };

  const getPayload = () => ({
    medications: selectedMedications,
    comments
  });

  const handleSignAndClose = () => {
    onSignAndClose(getPayload());
  };

  const handleSignAndPrint = () => {
    onSignAndPrint(getPayload());
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      slotProps={{
        paper: {
          sx: rxDialogStyles.paper
        }
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Medication Orders
          </Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
            Review and manage medication orders for the encounter.
          </Typography>
        </Box>

        <IconButton
          size="small"
          aria-label="Close prescription dialog"
          onClick={onClose}
          sx={dialogHeaderStyles.dialogheaderclose}>
          <CloseOutlined sx={rxDialogStyles.closeIcon} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={rxDialogStyles.content}>
        <Grid container spacing={1.5} sx={rxDialogStyles.contentGrid}>
          <Grid size={{ xs: 12, md: 8.5 }} sx={rxDialogStyles.gridItem}>
            <MedicationsAdd
              medications={selectedMedications}
              onAdd={handleAddMedication}
              onEdit={handleEditMedication}
              onDelete={handleDeleteMedication}
              comments={comments}
              onCommentsChange={setComments}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3.5 }} sx={rxDialogStyles.gridItem}>
            <MedicationsList
              medications={availableMedications}
              selectedMedicationIds={selectedMedicationIds}
              onSelect={handleSelectMedication}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <Box sx={rxDialogStyles.footer}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={rxDialogStyles.cancelButton}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSignAndClose}
          sx={rxDialogStyles.signCloseButton}>
          E-Sign &amp; Close
        </Button>

        <Button
          variant="contained"
          onClick={handleSignAndPrint}
          sx={rxDialogStyles.signPrintButton}>
          E-Sign &amp; Print
        </Button>
      </Box>
    </Dialog>
  );
};

RxDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSignAndClose: PropTypes.func,
  onSignAndPrint: PropTypes.func
};

RxDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSignAndClose: () => {},
  onSignAndPrint: () => {}
};

export default RxDialog;
